export const MinusCheckbox = () => (
  <svg width='8' height='2' viewBox='0 0 8 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 1H7' stroke='white' strokeWidth='2' strokeLinecap='round' />
  </svg>
);
